import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const TopicUpdateContent = lazy(() => import('../../../../components/Pages/Topics/[topicId]/Update'));

export default function TopicUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Topic Update page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <TopicUpdateContent />
      </Suspense>
    </Layout>
  );
}
